import { RAISIN_BANK_LOGO, RAISIN_LIGHT_BLUE_SITE_LOGO, RAISIN_LOGO } from '../../../../constants';
import { atMenus } from './atMenus';
import { comMenus } from './comMenus';
import { deMenus } from './deMenus';
import { deDKBMenus } from './deMenusDKB';
import { esMenus } from './esMenus';
import { fiMenus } from './fiMenus';
import { frMenus } from './frMenus';
import { gbMenus } from './gbMenus';
import { gbMSEMenus } from './gbMSEMenus';
import { ieMenus } from './ieMenus';
import { nlMenus } from './nlMenus';
import { plMenus } from './plMenus';
const getLocaleNavCollection = (isThemeV2) => {
    const logoUrl = isThemeV2 ? RAISIN_LIGHT_BLUE_SITE_LOGO : RAISIN_LOGO;
    const bankLogoUrl = isThemeV2 ? RAISIN_LIGHT_BLUE_SITE_LOGO : RAISIN_BANK_LOGO;
    return {
        'de-DE': deMenus(logoUrl),
        dkb_retail: deDKBMenus(logoUrl),
        mse_savings_hub: gbMSEMenus(logoUrl),
        'de-AT': atMenus(bankLogoUrl),
        'en-GB': gbMenus(logoUrl),
        'fr-FR': frMenus(logoUrl),
        'es-ES': esMenus(logoUrl),
        'nl-NL': nlMenus(logoUrl),
        'en-IE': ieMenus(logoUrl),
        'en-US': comMenus(logoUrl),
        'pl-PL': plMenus(logoUrl),
        'fi-FI': fiMenus(logoUrl),
    };
};
const DISTRIBUTOR_LOCALE_MAP = {
    dkb_retail: 'de-DE',
    mse_savings_hub: 'en-GB',
};
export const getRegistrationNavigation = (isThemeV2, locale, regflow) => {
    if (typeof getLocaleNavCollection(isThemeV2)[locale] === 'undefined') {
        return getLocaleNavCollection(isThemeV2)['en-US'];
    }
    if (DISTRIBUTOR_LOCALE_MAP[regflow] === locale)
        return getLocaleNavCollection(isThemeV2)[regflow];
    return getLocaleNavCollection(isThemeV2)[locale];
};
//# sourceMappingURL=index.js.map